module.exports = __webpack_public_path__ + "static/media/home-reload.1739d68c.svg";